/** Product owner — всегда видит админ-UI даже если в БД роль partner и т.д. */
export const OWNER_TELEGRAM_ID = 1261131511;

export function normalizeTelegramId(x: unknown): number | null {
  if (x == null) return null;
  const n = typeof x === 'bigint' ? Number(x) : Number(x);
  return Number.isFinite(n) ? Math.trunc(n) : null;
}

/** Владелец платформы — полный доступ при любой роли в БД (client, production, …). */
export function isPlatformOwner(telegramId: number | null | undefined): boolean {
  const tid = telegramId != null ? normalizeTelegramId(telegramId) : null;
  return tid === OWNER_TELEGRAM_ID;
}

export function canAccessAdminUi(p: {
  role: string | null;
  telegramId: number | null;
  serverAdminPanelHint?: boolean;
}): boolean {
  if (isPlatformOwner(p.telegramId)) return true;
  if (p.serverAdminPanelHint === true) return true;
  if (p.role === 'admin' || p.role === 'manager' || p.role === 'production' || p.role === 'measurer') return true;
  return false;
}

/** Смена статуса заказа (производство + менеджеры + полный админ). */
export function canUpdateOrderStatus(p: {
  role: string | null;
  telegramId: number | null;
  serverAdminPanelHint?: boolean;
}): boolean {
  if (isPlatformOwner(p.telegramId)) return true;
  if (hasFullAdminPowers(p)) return true;
  if (p.role === 'manager' || p.role === 'production') return true;
  return false;
}

/** Каталог (запись), медиа, витрина, статус заказа, скидка заказа, клиенты, замеры: не manager (см. require_full_admin / require_catalog_admin). */
export function canEditCatalog(p: {
  role: string | null;
  telegramId: number | null;
  serverAdminPanelHint?: boolean;
}): boolean {
  if (isPlatformOwner(p.telegramId)) return true;
  if (p.serverAdminPanelHint === true) return true;
  if (p.role === 'admin') return true;
  return false;
}

export function hasFullAdminPowers(p: {
  role: string | null;
  telegramId: number | null;
  serverAdminPanelHint?: boolean;
  serverFullAdminHint?: boolean;
}): boolean {
  if (isPlatformOwner(p.telegramId)) return true;
  if (p.serverFullAdminHint === true) return true;
  return canEditCatalog(p);
}

/** Ограничение UI «только заказы» — не для владельца, даже если роль production. */
export function isProductionUiSandbox(p: {
  role: string | null;
  telegramId: number | null;
}): boolean {
  if (isPlatformOwner(p.telegramId)) return false;
  return p.role === 'production';
}
